import { Link } from "react-router-dom";
import { hotRanks } from "@/mocks/fancha";

const rankColor = (rank: number) =>
  rank === 1
    ? "bg-primary-500 text-background-50"
    : rank === 2
      ? "bg-primary-300 text-background-50"
      : rank === 3
        ? "bg-accent-400 text-foreground-900"
        : "bg-background-200 text-foreground-600";

export default function RankSection() {
  return (
    <section id="rank" className="scroll-mt-20 bg-foreground-950 py-12 text-background-100 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-400">HOT BOARD</p>
            <h2 className="mt-2 font-heading text-2xl font-black text-background-50 md:text-3xl">
              本周反转热度榜
            </h2>
            <p className="mt-2 max-w-xl text-sm text-background-200/80">
              基于搜索量、讨论量与全平台考古热度的综合榜单，实时反映当下最「烫手」的反差事件。
            </p>
          </div>
          <div className="inline-flex items-center gap-2 rounded-full bg-background-100/10 px-4 py-2 text-xs text-background-200/80">
            <i className="ri-time-line" /> 数据截至 2026-09-06 20:00
          </div>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {hotRanks.map((r) => (
            <li key={r.id}>
              <Link
                to={`/topic/${r.id}`}
                className="group flex h-full flex-col rounded-2xl border border-background-100/10 bg-background-100/[0.04] p-5 transition-colors hover:border-accent-400/40 hover:bg-background-100/[0.08]"
              >
                <div className="flex items-start gap-4">
                  <span
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-heading text-lg font-black ${rankColor(r.rank)}`}
                  >
                    {r.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-background-50">
                      {r.title}
                    </h3>
                    <p className="mt-1 text-xs text-background-200/70">{r.name}</p>
                  </div>
                </div>
                <div className="mt-4 flex items-center justify-between border-t border-background-100/10 pt-4 text-xs">
                  <div className="flex flex-wrap gap-1.5">
                    {r.tags.map((t) => (
                      <span key={t} className="whitespace-nowrap rounded-full bg-accent-400/15 px-2 py-0.5 text-accent-300">
                        #{t}
                      </span>
                    ))}
                  </div>
                  <div className="flex shrink-0 items-center gap-3 text-background-200/80">
                    <span className="font-heading text-lg font-black text-accent-300">{r.score}</span>
                    <span
                      className={`inline-flex items-center gap-0.5 whitespace-nowrap ${
                        r.trend > 0 ? "text-primary-400" : r.trend < 0 ? "text-background-300" : "text-background-200/50"
                      }`}
                    >
                      <i className={r.trend > 0 ? "ri-arrow-up-line" : r.trend < 0 ? "ri-arrow-down-line" : "ri-subtract-line"} />
                      {r.delta}
                    </span>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}